import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { PaginationFilter } from '../models/pagination-filter';
import { DetachedServicesReportFilter } from '../pages/billing/detached-services/detached-report-filter';
import { DetachedServicesReportResponse } from '../pages/billing/detached-services/detached-report-data';

@Injectable({
  providedIn: 'root'
})
export class DetachedServicesReportService {

  constructor(private http: HttpClient) { }

  getDetachedServicesReport(filter: DetachedServicesReportFilter, paginationFilter: PaginationFilter): Observable<DetachedServicesReportResponse> {

    let params = new HttpParams();
    params = params.set('page', paginationFilter.page.toString());
    params = params.set('size', paginationFilter.size.toString());
    
    if (paginationFilter.sort && paginationFilter.order) {
      params = params.set('sort', `${paginationFilter.sort},${paginationFilter.order}`);
    }
    
    return this.http.post<any>(
      environment.apiHost + '/api-core/secure/reports/detached-services',
      filter,
      { params }
    ).pipe(
      map((response: any) => response as DetachedServicesReportResponse)
    );
  }

  getDetachedServicesReportSimple(filter: DetachedServicesReportFilter, paginationFilter: PaginationFilter, format: string): Observable<DetachedServicesReportResponse | ArrayBuffer> {

    let params = new HttpParams();
    params = params.set('page', paginationFilter.page.toString());
    params = params.set('size', paginationFilter.size.toString());

    if (paginationFilter.sort && paginationFilter.order) {
      params = params.set('sort', `${paginationFilter.sort},${paginationFilter.order}`);
    }

    if (format.toUpperCase() === 'PDF') {
      return this.http.post(
        environment.apiHost + '/api-core/secure/reports/detached-simple/' + format,
        filter,
        { 
          params,
          responseType: 'arraybuffer'
        }
      );
    } else {
      return this.http.post<any>(
        environment.apiHost + '/api-core/secure/reports/detached-simple/' + format,
        filter,
        { params }
      ).pipe(
        map((response: any) => response as DetachedServicesReportResponse)
      );
    }
  }

  getDetachedServicesReportByCustomer(filter: DetachedServicesReportFilter, paginationFilter: PaginationFilter, format: string): Observable<DetachedServicesReportResponse | ArrayBuffer> {

    let params = new HttpParams();
    params = params.set('page', paginationFilter.page.toString());
    params = params.set('size', paginationFilter.size.toString());

    if (format.toUpperCase() === 'PDF') {
      return this.http.post(
        environment.apiHost + '/api-core/secure/reports/detached-by-customer/' + format,
        filter,
        { 
          params,
          responseType: 'arraybuffer'
        }
      );
    } else {
      return this.http.post<any>(
        environment.apiHost + '/api-core/secure/reports/detached-by-customer/' + format,
        filter,
        { params }
      ).pipe(
        map((response: any) => response as DetachedServicesReportResponse)
      );
    }
  }

}